export function getMapCenter(fenceGeo){
    if (fenceGeo.type === 'circle'){
        return fenceGeo.coordinates;
    }

    if (fenceGeo.type === 'Point'){
        return {
            lat: fenceGeo.coordinates[1],
            lng: fenceGeo.coordinates[0],
        };
    }

    if (fenceGeo.type === 'polygon' || fenceGeo.type === 'Polygon'){
        let coords = fenceGeo.coordinates[0];

        if (coords.length < 1)return;
        
        let minLng = coords[0][0];
        let maxLng = coords[0][0];

        let minLat = coords[0][1];
        let maxLat = coords[0][1];

        for (let c = 0; c < coords.length; c += 1){  
        minLng = Math.min(minLng, coords[c][0]);
        maxLng = Math.max(maxLng, coords[c][0]);

        minLat = Math.min(minLat, coords[c][1]);
        maxLat = Math.max(maxLat, coords[c][1]);
        }

        return {
            lat: (minLat + maxLat)/2,
            lng: (minLng + maxLng)/2
        };
    }
}


// WEBPACK FOOTER //
// ./src/shared/helpers/fence.js